// extracted by mini-css-extract-plugin
export default {"emptyDataWrap":"style_emptyDataWrap__tIozb","emptyDataText":"style_emptyDataText__tjdcZ"};